/**
 * @deprecated use validators from src/utils/validators.ts or simple native checks such as `if (value)`
 */
export default function check(value: any, criterions: any) {
  if (criterions.indexOf('undefined') !== -1) {
    if (typeof value === 'undefined') {
      return true;
    }
  }
  if (criterions.indexOf('null') !== -1) {
    if (value === null) {
      return true;
    }
  }
  if (criterions.indexOf('empty') !== -1) {
    if (value === '' || (value.constructor === Array && value.length === 0)) {
      return true;
    }
  }
  if (criterions.indexOf('0') !== -1) {
    if (value === 0) {
      return true;
    }
  }
  if (criterions.indexOf('false') !== -1) {
    if (value === false) {
      return true;
    }
  }
  if (criterions.indexOf(-1) !== -1) {
    if (value === -1) {
      return true;
    }
  }
  return false;
}
